/**
 * Browser URL for a storefront hostname. Deployed domains are https; in local
 * dev the storefront Vite server runs on :3020 and tenants resolve as
 * {slug}.localhost (see apps/storefront).
 */
export function storefrontUrl(hostname: string): string {
  return hostname === "localhost" || hostname.endsWith(".localhost")
    ? `http://${hostname}:3020`
    : `https://${hostname}`;
}

/** The tenant's canonical storefront hostname: primary first, then any active row. */
export function primaryStorefrontHostname(
  domains: { hostname: string; status: string; isPrimary: boolean }[],
): string | null {
  const active = domains.filter((d) => d.status === "active");
  return (active.find((d) => d.isPrimary) ?? active[0])?.hostname ?? null;
}
